// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import React, { ReactNode, useContext, useEffect, useState } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { CustomerContext } from "components/App/DashboardApp";
import HealthPulseFooter from "config/HealthPulse/CustomComponents/HealthPulseFooter";
import Measure from "react-measure";
import PageFooter from "./PageFooter";
import { useWindowHeight } from "@react-hook/window-size";

interface PageContentProps {
  children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footerMeasurer: {
      borderTop: "1px solid transparent",
      boxSizing: "border-box",
    },
  })
);

export default (props: PageContentProps) => {
  const customerConfig = useContext(CustomerContext);
  const windowHeight = useWindowHeight();
  const [footerHeight, setFooterHeight] = useState(0);
  const [contentMinHeight, setContentMinHeight] = useState(0);

  useEffect(() => {
    const nav = document.getElementById("navbar");
    if (!nav) {
      return;
    }
    const navHeight = nav.getBoundingClientRect().height;
    setContentMinHeight(windowHeight - navHeight - footerHeight);
  }, [footerHeight, windowHeight]);

  const classes = useStyles();

  let footer = <PageFooter />;
  if (customerConfig?.name === "HealthPulse@home") {
    footer = <HealthPulseFooter />;
  }

  return (
    <>
      <section
        className={"section"}
        style={{
          minHeight: `${contentMinHeight}px`,
        }}
      >
        <div>{props.children}</div>
      </section>
      <Measure
        bounds
        onResize={contentRect => {
          if (contentRect?.bounds) {
            setFooterHeight(contentRect.bounds.height);
          }
        }}
      >
        {({ measureRef }) => {
          return (
            <div ref={measureRef} className={classes.footerMeasurer}>
              {footer}
            </div>
          );
        }}
      </Measure>
    </>
  );
};
